import React from "react";
import Navbar from "../navbar/navbar-desktop.tsx";
import Footer from "../footer/footer.tsx";
import { Helmet } from "react-helmet";
import { FaInstagram, FaFacebook, FaYoutube, FaGooglePlus } from "react-icons/fa";

const Kontakt: React.FC = () => {
  return (
    <>
      {/* ================= HEAD ================= */}
      <Helmet>
        <title>Kontakt | Hospůdka pod Rablinů</title>
        <meta
          name="description"
          content="Chcete si rezervovat stůl, ubytování nebo máte dotaz? Kontaktujte nás telefonicky, e-mailem nebo osobně."
        />
      </Helmet>

      {/* ================= NAVBAR (IZOLACE) ================= */}
      <div className="relative z-50 isolate">
        <Navbar />
      </div>

      {/* ================= OBSAH ================= */}
      <main className="bg-[#F5E7CC] text-[#32180d] overflow-x-hidden">

        {/* ================= NADPIS ================= */}
        <section className="bg-white py-20 text-center">
          <h1 className="text-3xl md:text-4xl font-bold font-serif">
            KONTAKT
          </h1>
        </section>

        {/* ================= KONTAKTNÍ INFORMACE ================= */}
        <section className="max-w-4xl mx-auto px-6 py-20 text-center space-y-6">

          <h2 className="text-2xl font-bold font-serif">
            Hospůdka pod Rablinů
          </h2>

          <p>
            <strong>Adresa:</strong> Kašava 302, 763 19
          </p>

          <p>
            <strong>GPS:</strong> 49.297828, 17.768988
          </p>

          <p className="text-lg">
            <strong>Telefon:</strong>{" "}
            <a
              href="tel:+420608608101"
              className="text-[#85300c] font-semibold hover:underline"
            >
              +420 608 608 101
            </a>
          </p>

          <p>
            Poslední objednávka na jídlo je přijímána{" "}
            <strong>Po – Ne v 19:00</strong>
          </p>

          <div className="space-y-1">
            <p>
              <strong>Ubytování:</strong>{" "}
              <a
                href="mailto:ubytovani@hospudkapodrablinu.cz"
                className="text-[#85300c] hover:underline"
              >
                ubytovani@hospudkapodrablinu.cz
              </a>
            </p>

            <p>
              <strong>Wellness:</strong>{" "}
              <a
                href="mailto:wellness@hospudkapodrablinu.cz"
                className="text-[#85300c] hover:underline"
              >
                wellness@hospudkapodrablinu.cz
              </a>
            </p>

            <p>
              <strong>Akce:</strong>{" "}
              <a
                href="mailto:info@hospudkapodrablinu.cz"
                className="text-[#85300c] hover:underline"
              >
                info@hospudkapodrablinu.cz
              </a>
            </p>
          </div>

          <a
            href="/img/hospudka-pod-rablinu-logo.png"
            download
            className="inline-block mt-6 text-sm font-serif font-bold text-[#531d08] underline"
          >
            Stáhnout logo Hospůdka pod Rablinů
          </a>

        </section>

        {/* ================= SOCIÁLNÍ SÍTĚ ================= */}
        <section className="py-10 text-center">
          <h3 className="text-xl font-bold font-serif mb-4">
            Sociální sítě
          </h3>

          <div className="flex justify-center gap-6 text-3xl text-[#531d08]">
            <a
              href="https://www.instagram.com/hospudka_pod_rablinu/"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-[#85300c]"
            >
              <FaInstagram />
            </a>
            <a
              href="https://www.facebook.com/hospudkapodrablinuofficial/"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-[#85300c]"
            >
              <FaFacebook />
            </a>
            <a
              href="#"
              className="hover:text-[#85300c]"
            >
              <FaYoutube />
            </a>
            <a
              href="https://www.google.com/search?q=hospudka+pod+rablinu"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-[#85300c]"
            >
              <FaGooglePlus />
            </a>
          </div>
        </section>

        {/* ================= MAPA ================= */}
        <section className="w-full h-[400px]">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d6457.226696882322!2d17.769411!3d49.297946!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4713758a2bdaed6f%3A0x807b892635f2c5b8!2sHosp%C5%AFdka%20Pod%20Rablin%C5%AF!5e1!3m2!1scs!2sus!4v1732654509624!5m2!1scs!2sus"
            loading="lazy"
            className="w-full h-full border-y-4 border-white"
          />
        </section>

        {/* ================= FOOTER () ================= */}
        <div className="[all:unset] block">
          <Footer />
        </div>

      </main>
    </>
  );
};

export default Kontakt;